import React from 'react';
import { motion } from 'framer-motion';

export default function BlogSkeleton() {
  return (
    <section className="pt-24 pb-16">
      <div className="mx-auto w-[95%] sm:w-[92%] md:w-[90%] lg:max-w-[80%]">
        {/* Header */}
        <div className="text-center max-w-4xl mx-auto mb-8">
          <motion.div className="h-10 w-56 bg-gray-600/50 rounded mx-auto mb-3" animate={{ opacity: [0.5, 1, 0.5] }} transition={{ duration: 1.2, repeat: Infinity }} />
          <motion.div className="h-4 w-80 bg-gray-600/50 rounded mx-auto" animate={{ opacity: [0.5, 1, 0.5] }} transition={{ duration: 1.2, repeat: Infinity, delay: 0.2 }} />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Main Article */}
          <div className="lg:col-span-2">
            <div className="relative overflow-hidden rounded-xl border border-white/10 bg-[#121212] shadow-2xl">
              {/* Image */}
              <div className="aspect-[21/9] w-full bg-gray-700/50 animate-pulse" />

              {/* Content */}
              <div className="px-6 md:px-10 pb-8 pt-6 space-y-4">
                <motion.div className="h-8 w-2/3 bg-gray-600/50 rounded" animate={{ opacity: [0.5, 1, 0.5] }} transition={{ duration: 1.2, repeat: Infinity }} />
                <div className="space-y-2">
                  <motion.div className="h-4 w-full bg-gray-600/40 rounded" animate={{ opacity: [0.5, 1, 0.5] }} transition={{ duration: 1.2, repeat: Infinity, delay: 0.1 }} />
                  <motion.div className="h-4 w-11/12 bg-gray-600/40 rounded" animate={{ opacity: [0.5, 1, 0.5] }} transition={{ duration: 1.2, repeat: Infinity, delay: 0.2 }} />
                  <motion.div className="h-4 w-10/12 bg-gray-600/40 rounded" animate={{ opacity: [0.5, 1, 0.5] }} transition={{ duration: 1.2, repeat: Infinity, delay: 0.3 }} />
                </div>
                <div className="mt-6 flex items-center gap-3">
                  <div className="min-w-8 w-8 h-8 rounded-full bg-gray-600/60" />
                  <motion.div className="h-4 w-28 bg-gray-600/40 rounded" animate={{ opacity: [0.5, 1, 0.5] }} transition={{ duration: 1.2, repeat: Infinity, delay: 0.2 }} />
                  <div className="mx-2 h-4 w-px bg-white/10" />
                  <motion.div className="h-4 w-24 bg-gray-600/40 rounded" animate={{ opacity: [0.5, 1, 0.5] }} transition={{ duration: 1.2, repeat: Infinity, delay: 0.3 }} />
                </div>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <aside className="space-y-6">
            {/* Search */}
            <div className="rounded-xl border border-white/10 bg-[#1111115d] p-4">
              <motion.div className="h-5 w-32 bg-gray-600/50 rounded mb-3" animate={{ opacity: [0.5, 1, 0.5] }} transition={{ duration: 1.2, repeat: Infinity }} />
              <div className="relative">
                <motion.div className="h-9 w-full bg-gray-600/30 rounded" animate={{ opacity: [0.5, 1, 0.5] }} transition={{ duration: 1.2, repeat: Infinity, delay: 0.2 }} />
              </div>
            </div>

            {/* Other Blogs */}
            <div className="rounded-xl border border-white/10 bg-[#1111115d] p-4">
              <motion.div className="h-5 w-28 bg-gray-600/50 rounded mb-3" animate={{ opacity: [0.5, 1, 0.5] }} transition={{ duration: 1.2, repeat: Infinity }} />
              <div className="divide-y divide-white/10">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div key={i} className="py-3 flex items-center gap-3">
                    <div className="w-12 h-12 rounded bg-gray-600/50" />
                    <div className="min-w-0 flex-1 space-y-2">
                      <motion.div className="h-4 w-40 bg-gray-600/40 rounded" animate={{ opacity: [0.5, 1, 0.5] }} transition={{ duration: 1.2, repeat: Infinity, delay: i * 0.05 }} />
                      <motion.div className="h-3 w-24 bg-gray-600/30 rounded" animate={{ opacity: [0.5, 1, 0.5] }} transition={{ duration: 1.2, repeat: Infinity, delay: i * 0.05 + 0.1 }} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
